import { Instagram, MapPin, Phone, Clock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { CONTACT, waLink, MESSAGES } from "@/constants/site";

export const Footer = () => (
  <footer className="border-t border-white/5 bg-[#0A0A0B]">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
      <div>
        <Logo />
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#A1A09E]">
          Extensão capilar, mega hair, cabelo humano, perucas e topos capilares
          para realçar a sua beleza.
        </p>
      </div>
      <div>
        <p className="mb-6 text-xs font-bold uppercase tracking-[0.3em] text-[#F9F8F6]">Contato</p>
        <ul className="space-y-4 text-sm text-[#A1A09E]">
          <li>
            <a
              href={CONTACT.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-[#F9F8F6]"
            >
              <Instagram className="h-4 w-4 text-[#F9F8F6]" />
              {CONTACT.instagram}
            </a>
          </li>
          <li>
            <a
              href={CONTACT.phoneUrl}
              data-testid="footer-phone-link"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-[#F9F8F6]"
            >
              <Phone className="h-4 w-4 text-[#F9F8F6]" />
              {CONTACT.phone}
            </a>
          </li>
          <li>
            <a
              href={waLink(MESSAGES.flutuante)}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-[#F9F8F6]"
            >
              <WhatsAppIcon className="h-4 w-4 text-[#F9F8F6]" />
              WhatsApp direto
            </a>
          </li>
          <li data-testid="footer-hours" className="flex items-center gap-3">
            <Clock className="h-4 w-4 text-[#F9F8F6]" />
            Todos os dias, das 08h às 19h
          </li>
        </ul>
      </div>
      <div>
        <p className="mb-6 text-xs font-bold uppercase tracking-[0.3em] text-[#F9F8F6]">Localização</p>
        <p data-testid="footer-address" className="flex items-start gap-3 text-sm leading-relaxed text-[#A1A09E]">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#F9F8F6]" />
          {CONTACT.address}
        </p>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 text-center text-xs tracking-wide text-[#A1A09E]/60">
      © 2026 Salão Estrela — Todos os direitos reservados. Sobradinho, Brasília/DF.
    </div>
  </footer>
);
